import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root',
})
export class HomeGuard implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) {}

  // Checks if the user can activate the route
  async canActivate(): Promise<boolean> {
    if(!this.tokenService.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }else{
      return true;
    }
  }
}
